import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Sparte, TextNodeType } from '@mwe/models';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductIconsComponent } from '../../product-icons/product-icons.component';

@Component({
  selector: 'mwe-clickable-products-card',
  templateUrl: './clickable-products-card.component.html',
  imports: [TranslatePipe, ProductIconsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClickableProductsCardComponent {
  readonly categories = input<Sparte[]>();
  readonly categoryTranslationKeys = input<Record<string, string>>({});
  readonly ariaTitle = input<string>();
  readonly dataTest = input<string>();
  readonly hasAutoFocus = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly textNodeType = input<TextNodeType>('h6');

  readonly cardClicked = output();
}
